import { ToolkitListingID, isUndefined } from '@aloft/toolkit-shared';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { useToolkitContext } from '../../../hooks/api/toolkitContext.ts';
import { useToolkitControllerGlobal } from '../useToolkitControllerGlobal.ts';
import { ListingResult } from './types.ts';

export const useGetListing = (
  listingID?: ToolkitListingID,
  disabled = false,
): UseQueryResult<ListingResult> => {
  const { fetcherOptions } = useToolkitContext();
  const { mlsListingsBatcher } = useToolkitControllerGlobal();

  return useQuery({
    queryKey: ['AbodeListing', listingID ?? 'missing_listing'],
    queryFn: async () =>
      isUndefined(listingID)
        ? ({ status: 'missing' } as const)
        : mlsListingsBatcher.fetch(listingID, fetcherOptions),
    gcTime: Infinity,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !disabled,
  });
};
